import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { environment } from '@ninety/ui/web/environments';

import { DatadogRumConfig, DatadogRumService } from './datadog-rum.service';

export const DATADOG_RUM_CONFIG = new InjectionToken<DatadogRumConfig | null>('DATADOG_RUM_CONFIG');

function getDefaultRumConfig(config?: Partial<DatadogRumConfig>): DatadogRumConfig | null {
  if (!environment.dataDogRumApplicationId) {
    return null;
  }

  return {
    applicationId: environment.dataDogRumApplicationId,
    clientToken: environment.dataDogClientToken,
    site: 'datadoghq.com',
    env: environment.env,
    hostedEnvironment: environment.hostedEnvironment,
    service: environment.service,
    version: environment.ninetyReleaseVersion ?? environment.appVersion,
    ...config,
  };
}

/**
 * Provides DatadogRumService. RUM is inited in main.ts; forRoot connects the service (global context,
 * user/account sync). Also provide DatadogRumUserSyncService (from state) so user/account are synced.
 */
@NgModule()
export class DatadogRumModule {
  static forRoot(config?: Partial<DatadogRumConfig>): ModuleWithProviders<DatadogRumModule> {
    return {
      ngModule: DatadogRumModule,
      providers: [
        { provide: DATADOG_RUM_CONFIG, useValue: getDefaultRumConfig(config) },
        {
          provide: DatadogRumService,
          useFactory: (c: DatadogRumConfig | null) => {
            const service = new DatadogRumService();
            if (c?.applicationId) {
              service.connect(c);
            }
            return service;
          },
          deps: [DATADOG_RUM_CONFIG],
        },
      ],
    };
  }
}
